export const DEFAULT_GAS_CHANNEL = 'atlaskit';
